import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { catchError, of } from 'rxjs';
import { AuthService } from 'app/authentication/auth/auth.service';

type PlatformMessage = {
    id: string;
    message: string;
    severity?: string;
    enabled?: boolean;
};

@Component({
    selector: 'platform-global-message',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div
            *ngIf="active"
            class="platform-global-message w-full px-4 py-2 text-sm text-center"
            [class.bg-blue-100]="severity === 'info'"
            [class.text-blue-950]="severity === 'info'"
            [class.bg-amber-100]="severity === 'warning'"
            [class.text-amber-950]="severity === 'warning'"
            role="status"
        >
            {{ text }}
        </div>
    `,
})
export class PlatformGlobalMessageComponent implements OnInit {
    active = false;
    text = '';
    severity = 'info';

    constructor(
        private _http: HttpClient,
        private _authService: AuthService
    ) {}

    ngOnInit(): void {
        if (!this._authService.accessToken) {
            return;
        }

        this._http
            .get<PlatformMessage[]>('/api/common/messages')
            .pipe(catchError(() => of([])))
            .subscribe((rows) => {
                const row = Array.isArray(rows) ? rows.find((r) => r.enabled !== false) ?? rows[0] : null;
                if (row?.message) {
                    this.active = true;
                    this.text = row.message;
                    this.severity = row.severity || 'info';
                }
            });
    }
}
